//@flow
import React from "react";
import "./loading.scss";
import ImageLoading from "./loading.gif";

export function Loading() {
  return (
    <div className="image-loading">
      <img src={ImageLoading} alt="loading" />
    </div>
  );
}
